import { useSelector, useDispatch } from 'react-redux'
import { setUser, appendUserData, initialState } from 'store/auth/userSlice'
import {
    apiSignIn,
    apiSignOut,
    apiSignUp,
    apiAdminSignIn,
    apiAdminSignOut,
} from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import jwt_decode from 'jwt-decode'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async (values) => {
        try {
            const resp = await apiSignIn(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data) {
                    const data = jwt_decode(token)
                    dispatch(
                        appendUserData({ account_type: data.account_type })
                    )
                }

                navigate(appConfig.authenticatedEntryPath)

                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {
                const { token } = resp.data
                //prevent Looping bcus of sign in set as success
                const redirectUrl = query.get(REDIRECT_URL_KEY)

                navigate(
                    redirectUrl
                        ? redirectUrl
                        : appConfig.unAuthenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const adminsignIn = async (values) => {
        try {
            const resp = await apiAdminSignIn(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data) {
                    const data = jwt_decode(token)
                    dispatch(
                        appendUserData({ account_type: data.account_type })
                    )
                }

                navigate(appConfig.authenticatedEntryPath)

                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        await apiSignOut()
        handleSignOut()
    }

    const adminsignOut = async () => {
        await apiAdminSignOut()
        handleSignOut()
    }

    return {
        authenticated: token && signedIn,
        signIn,
        adminsignIn,
        signUp,
        signOut,
        adminsignOut,
    }
}

export default useAuth
